import React from 'react'
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import AppButton from "../../ui/AppButton";
import Alert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import NumberFormatCustom from "../../helpers/NumberFormatCustom";
import InfoIcon from '@material-ui/icons/Info';
import InputAdornment from '@material-ui/core/InputAdornment';
import Modal from "@material-ui/core/Modal";

class DonationsForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
        }
    }

    handleClickInfo = () => {
        this.setState({openModal: true})
    }

    handleCloseModal = () => {
        this.setState({openModal: false})
    };

    render() {

        const {donationValue, onChange, onSubmit} = this.props;

        return (

            <div>
                <form onSubmit={onSubmit}>
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="center">

                        <Card style={{padding: '15px', width: '40%', marginBottom: '1%'}}>

                            <Grid container>
                                <Grid item xs={8}>
                                    <TextField
                                        id='donationValue'
                                        name='donationValue'
                                        value={donationValue}
                                        label='Valor aporte voluntario'
                                        onChange={onChange}
                                        style={{width: '100%'}}
                                        variant="outlined"
                                        required={true}
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <InfoIcon color='primary' onClick={this.handleClickInfo}
                                                              style={{cursor: 'pointer'}}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <AppButton
                                        type='submit'
                                        label='Enviar'
                                        size='large'
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </form>

                <Modal
                    open={this.state.openModal}
                    onClose={this.handleCloseModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Alert style={{textAlign: 'left'}} severity="info">
                        * El valor del aporte será agregado a su próxima factura.<br/>
                        * Luego de realizar su aporte voluntario tiene un máximo de 2 días si desea borrarlo.<br />
                        * Decreto 517: "Aporte voluntario dirigido a otorgar un alivio económico al pago de los servicios públicos domiciliarios de energía eléctrica de los estrato 1 y 2".
                    </Alert>
                </Modal>

            </div>
        );
    }
}

export default DonationsForm